export enum NumberConstants {
  MIN_PASSWORD = 8
}
